<template>

    <div class="account-container m-xl-0 booking">

        <router-link class="return-to-bookings" v-bind:to="{name : 'account_spa_bookings'}">
            Back to all bookings
        </router-link>

        <div v-if="isLoading" class="d-flex justify-content-center">
            <loader></loader>
        </div>


        <div v-if="!isLoading && booking != null">
            <div class="row">
                <div class="col-xl-12">
   
                        <h2>{{formatDate(booking.Date)}}</h2>
          
                </div>
                <div class="col-xl-12 mb-4 ">
                    <div class="row">
                        <div class="col-xl-12">


                            <a class="lnk-print mr-2"
                               v-on:click="printWindow();">Print Confirmation</a>

                        </div>
                        <div class="col-xl-12">


                            <a class="lnk-email ml-2"
                               v-on:click="resendConfirmation()">Resend confirmation</a>

                        </div>

                    </div>
                </div>
            </div>


            <div v-if="sendEmail" class="row justify-content-start ">
                <div class="col-xl-24  mb-5">


                    <Form @submit="onSendEmail" :validation-schema="schema">

                        <div class=" p-5 bg-white has-shadow ">
                            <h3>Resend Confirmation</h3>
                            <p>Enter an email address below and we'll send a copy of your confirmation.</p>

                            <div v-if="!isEmailLoading">
                                <div class="form-group row  flex-row g-0">
                                    <div class="col-xl-16 mb-3 mb-xl-0">

                                        <Field name="emailAddress" class="form-control" placeholder="Email address"></Field>

                                    </div>
                                    <button class="btn btn--gold col-12 col-xl-8" type="submit">Send</button>
                                </div>
                                <div class="form-group row  flex-row g-0">
                                    <div class="col-xl-16 mb-3 mb-xl-0">
                                        <ErrorMessage name="emailAddress" class="error-message" />


                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="form-group row  flex-row g-0">
                                    <div class="col-xl-16 mb-3 mb-xl-0">

                                        <div class="d-flex justify-content-center">
                                            <loader></loader>
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>


                    </Form>
                </div>
            </div>




            





            <div class="row mt-4 mb-4 spa-summary">
                <div class="col-xl-18 ">
                    <div class="has-shadow panel panel--primary">



                        <div class="bg-white h-100 p-5">
                            <h2 v-if="booking?.Item?.Package?.DisplayName == null">Your Spa Treatment booking summary</h2>
                            <h2 v-else>Your Spa Day booking summary</h2>


                            <div class="row mb-4">
                                <div class="col-24">

                                    <info-box v-bind:type="'alert'">
                                        <template v-slot:body>
                                            <div class="d-flexf flex-column justify-content-between">
                                                <span class="heading">
                                                    Need to change or cancel?
                                                </span>
                                                <p>
                                                    Should you need to change, cancel or modify your booking please contact the Spa team on 01325 729999. In the event of a cancellation, a 50% refund will be given except when the cancellation takes place less that 48 hours prior to your confirmed booking date, in which case the full cost will be incurred.
                                                </p>


                                            </div>
                                        </template>
                                    </info-box>


                                </div>
                            </div>

                            <div class="spa-summary-group">

                                <label>
                                    Date &amp; Guests
                                </label>
                                <div class="row mb-2">
                                    <div class="col-5">
                                        Date
                                    </div>
                                    <div class="col-19">
                                        {{formatDate(booking.Date)}}
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-5">
                                        Guests
                                    </div>
                                    <div class="col-19">
                                        {{booking.Item.Clients.length}}
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-5">
                                        Spa Package

                                    </div>
                                    <div class="col-19">
                                        {{booking.Item?.Package?.DisplayName}}
                                    </div>
                                </div>

                            </div>

                            <div class="spa-summary-group"
                                 v-if="anyTreatments"
                                 v-for="(guest, index) in booking.Item.Clients">

                                <label>
                                    {{guest.FirstName}}'s Treatments
                                </label>
                                <div class="row mb-3">
                                    <div class="col-24 col-lg-5">
                                        Treatments
                                    </div>
                                    <div class="col-24 col-lg-19">
                                        <ul class="treatments-list">
                                            <li v-for="(t, index) in getTreatments(index)">
                                                <div class="row">
                                                    <div class="col-18">


                                                        {{t.Details.DisplayName}} {{t.Details.Duration}} minutes
                                                    </div>
                                                    <!--<div class="col-6">
                                                        <strong>
                                                            &pound;{{t.Details.Price}}

                                                        </strong>
                                                    </div>-->
                                                </div>

                                            </li>
                                        </ul>
                                    </div>

                                </div>


                            </div>





                            <!--<div v-if="hasAddOns">
                        <hr />
                        <h2>Add Ons</h2>


                        <div class="spa-summary-group"
                             v-for="(addOn, index) in search.groupAddOns">

                            <label>
                                {{addOn.content.DisplayName}}
                            </label>
                            <div class="row mb-3">
                                <div class="col-24">
                                    <div class="summary-add-on p-3 position-relative">

                                        <div class="row">
                                            <div class="col-24">
                                                <div class="row">
                                                    <div class="col-20">
                                                        <label class="small">
                                                            {{search.guests.length}}  {{search.guests.length == 1 ? 'pass' : 'passes'}} : {{formatTime(addOn.selection.StartDateTime)}} entry
                                                        </label>
                                                    </div>
                                                    <div class="col">
                                                        <strong class="mr-5">&pound;{{search.guests.length * addOn.selection.ActualPrice}}</strong>
                                                    </div>


                                                </div>

                                            </div>

                                        </div>
                                        <div class="row">

                                            <div class="col-24">
                                                <div v-html="addOn.content.Description">


                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>


                        </div>
                    </div>-->
                            <div>
                                <hr />
                                <h2>Your Bill</h2>
                            </div>
                            <div class="spa-summary-group">
                                <div class="row bill" v-if="isSpaDay">
                                    <div class="col-17">
                                        <div class="row mb-2">
                                            <div class="col-24 col-lg-7">
                                                Spa Days:
                                            </div>
                                            <div class="col-24 col-lg-17">
                                                {{booking.Item.Clients.length}} * &pound;{{booking.Item.Package.Price}} = <strong>&pound;{{booking.Item.Clients.length * booking.Item.Package.Price}}</strong>
                                            </div>
                                        </div>
                                        <!--<div class="row" v-if="hasAddOns">
                                    <div class="col-7">
                                        Add Ons:
                                    </div>
                                    <div class="col-17">

                                        &pound;{{addOnsTotal}}
                                    </div>
                                </div>-->

                                    </div>
                                    <div class="col-7 bordered">
                                        <span class="spa-total">Total: <span class="spa-total-amount">&pound;{{booking.Item.CalculatedAmount}}</span></span>
                                    </div>
                                </div>



                                <div class="row bill" v-else>
                                    <div class="col-17">
                                        <div class="row mb-2">
                                            <div class="col-24 col-xl-7">
                                                Treatments:
                                            </div>
                                            <div class="col-24 col-xl-17">

                                                &pound;{{treatmentsTotal}}
                                            </div>
                                        </div>
                                        <!--<div class="row" v-if="hasAddOns">
                                    <div class="col-7">
                                        Add Ons:
                                    </div>
                                    <div class="col-17">

                                        &pound;{{addOnsTotal}}
                                    </div>
                                </div>-->

                                    </div>
                                    <div class="col-7 bordered">
                                        <span class="spa-total">Total: <span class="spa-total-amount">&pound;{{booking.Item.CalculatedAmount}}</span></span>
                                    </div>
                                </div>







                            </div>
                            <div>

                                <div class="spa-itinerary">
                                    <div class="row mb-3">
                                        <div class="col-24">
                                            <hr />
                                            <h3 v-if="isSpaDay">Your Spa Day Itinerary</h3>
                                            <h3 v-else>Your Spa Treatment Itinerary</h3>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-24" v-if="isSpaDay">

                                            <info-box v-bind:type="'alert'">
                                                <template v-slot:body>
                                                    <div class="d-flexf flex-column justify-content-between">
                                                        <span class="heading">
                                                            Please arrive for your spa day 15 minutes before it is due to commence.
                                                        </span>
                                                        <p>
                                                            Rockliffe Hall reserves the right to amend treatment start times subject to availability.
                                                        </p>


                                                    </div>
                                                </template>
                                            </info-box>


                                        </div>

                                        <div class="col-24" v-else>
                                            <info-box v-bind:type="'alert'">
                                                <template v-slot:body>
                                                    <div class="d-flexf flex-column justify-content-between">
                                                        <span class="heading">
                                                            Please arrive for your treatment 15 minutes before it is due to commence.
                                                        </span>
                                                        <p>
                                                            Rockliffe Hall reserves the right to amend treatment start times subject to availability.
                                                        </p>


                                                    </div>
                                                </template>
                                            </info-box>
                                        </div>
                                    </div>

                                    <div class="row mt-4">
                                        <div class="col-24 col-lg-12 mb-4" v-for="(client, index) in booking.Item.Clients">
                                            <h3 class="mb-3">{{client.FirstName}}'s treatments</h3>

                                            <ul>


                                                <li v-for="(tt, ti) in clientItinerary(client, index)" class="item">
                                                    <div class="row">
                                                        <div class="col-4">

                                                            <span class="time">{{tt.StartTime}}</span>
                                                        </div>
                                                        <div class="col">

                                                            <span class="treatment">{{tt.DisplayName}}</span>
                                                        </div>
                                                    </div>

                                                </li>

                                                <li class="item" v-if="isSpaDay">
                                                    <div class="row">
                                                        <div class="col-4">

                                                            <span class="time">{{booking.Item.Package.EndTime}}</span>
                                                        </div>
                                                        <div class="col">

                                                            <span class="treatment">Depature</span>
                                                        </div>
                                                    </div>
                                                </li>

                                            </ul>




                                        </div>


                                    </div>



                                </div>
                            </div>

                        </div>
                    </div>


                </div>


            </div>





            <!--<div class="row mb-4">

        <div class="col-xl-12" v-for="(client, index) in booking.Item.Clients">

            <div class="room-booking-summary">

                <div class="has-shadow panel panel--primary">
                    <div class="row">
                        <div class="col-24">
                            <div class="room-leg-wrapper">
                                <h3 class="mb-0">{{client.Title}} {{client.FirstName}} {{client.LastName}}</h3>

                            </div>

                            <div class="room-detail-wrapper">

                                <div class="row my-4">
                                    <div class="col-24">

                                        <info-box v-bind:type="'alert'">
                                            <template v-slot:body>
                                                <div class="d-flexf flex-column justify-content-between">
                                                    <span class="heading">
                                                        Times here are requests only
                                                    </span>
                                                    <p>
                                                        The reservations team will be in touch to confirm shortly
                                                    </p>


                                                </div>
                                            </template>
                                        </info-box>


                                    </div>
                                </div>


                                <div class="spa-itinerary">
                                    <ul>
                                        <li class="item" v-for="(treatment, x) in getTreatments(index)">
                                            <div class="row">
                                                <div class="col-4">
                                                    <span class="time">{{formatTime(treatment.Details.StartDateTime)}}</span>
                                                </div>
                                                <div class="col">

                                                    <span class="treatment">{{treatment.Details.DisplayName}}</span>
                                                </div>
                                            </div>

                                        </li>

                                    </ul>
                                </div>





                            </div>


                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>-->
        </div>




    </div>





</template>

<script>

    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";

    import { _ } from 'vue-underscore';

    //import AccountSpaSummaryPanel from '../components/AccountSpaSummaryPanel.vue';
    //import AccountStayUpsell from '../components/AccountStayUpsell.vue';

    import InfoBox from '@/shared/components/InfoBox.vue';
    import Loader from '@/shared/components/Loader.vue';

    import { accountStore } from '../store/index';

    import spaapi from '@/shared/api/spa';

    export default {
        name: 'AccountSpaBookings',

        mounted() {
            var so = this;
            so.isLoading = true;

            if (this.configuration == null) {
                accountStore.dispatch("getConfiguration");
            }


            so.getBooking();

        },
        components: {
            Loader,

            InfoBox,
            Field,
            Form,
            ErrorMessage,
        },
        computed: {

            confirmationNumber() {
                return this.$route.params.id;
            },


            treatmentsTotal() {
                let result = 0;
         
                result = this.booking.Item.Items.reduce(function (previous, current) {
                    return previous + current.Price;
                }, 0);

                return result;
            },
            addOnsTotal() {
                let result = 0;
                //result = this.booking.Item.Items.reduce(function (previous, current) {
                //    return previous + current.Price;
                //}, 0);

                return result;
            },
            total() {
                return this.treatmentsTotal + this.addOnsTotal;;
            },

            isSpaDay() {
                return this.booking?.Item?.Package != null;
            },


            id() {
                return this.$route.params.id;
            },
            anyTreatments() {
                for (let i = 0; i < this.booking.Item.Clients.length; i++) {
                    if (this.getTreatments(i).length) {
                        return true;
                    }
                }
                return false;
            },
        },
        data() {

            const schema = yup.object().shape({
                emailAddress: yup.string().required().email().label("Email address"),
            });


            return {
                schema,
                booking: null,
                isLoading: false,
                isEmailLoading: false,
                isCancelling: false,
                isAmending: false,
                sendEmail: false,
            }
        },
        methods: {
            clientItinerary(client, ci) {

                let treatments = this.booking.Item.Items.filter(i => i.ClientIndex == ci);


                var result = [];

                if (treatments != null) {
                    for (let gi = 0; gi < treatments.length; gi++) {
                        var item = treatments[gi];
                        result.push({
                            DisplayName: item.DisplayName,
                            StartTime: moment(item.StartDateTime).format("HH:mm")
                        });


                    }



                    if (this.booking.Item?.RestaurantTime != null) {

                        result.push({
                            DisplayName: this.booking.Item.RestaurantTime.DisplayName,

                            StartTime: moment(this.booking.Item.RestaurantTime.Time).format("HH:mm")

                        });
                    }



                    if (client.ArrivalTime != null) {
                        result.push({
                            DisplayName: 'Arrival Time',
                            StartTime: moment(client.ArrivalTime, "HH:mm:ss").format("HH:mm")

                        });
                    }



                    var spaGarden = this.booking.Item?.SpaGardenTimes?.find(i => i.GuestIndex == ci)?.Selection
                    if (spaGarden != null) {
                        ;
                        result.push({
                            DisplayName: spaGarden?.GroupAppointmentTypeDescription,
                            StartTime: moment(spaGarden.StartDateTime).format("HH:mm")

                        });
                    }

                    return _.sortBy(result, function (item) {
                        return moment(item.StartTime, "HH:mm")
                    });


                    return result;
                }

             
            },


            getTreatments(clientIndex) {
                let result = [];


                if (this.booking.Item.Items != undefined && this.booking.Item.Items != null) {
                    let clientItems = this.booking.Item.Items.filter(i => i.ClientIndex == clientIndex);

                    clientItems = _.sortBy(clientItems, function (i) {

                        return moment(i.StartDateTime);
                    })

                    for (let ri = 0; ri < clientItems.length; ri++) {

                        let details = clientItems[ri];
                        result.push({
                            Details: details,
                        })

                    }
                }


                return result;
            },



            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            },

            getBooking() {
                let so = this;
                spaapi.fetchBooking(this.id, t => {

                    so.booking = t;
                    so.isLoading = false;
                });
            },


            formatDate(date) {
                return moment(date).format("Do MMMM YYYY");
            },
            formatTimeOnly(input) {
                return moment(input, "HH:mm:ss").format("HH:mm");
            },
            formatTime(date) {
                return moment(date).format("HH:mm");
            },

            formatStayDate(input) {
                return moment(input).format("Do MMMM YYYY");
            },
            printWindow: function () {
                window.print();
            },
            onSendEmail(values) {
                this.isEmailLoading = true;

                let payload = {
                    confirmation: this.confirmationNumber,
                    emailAddress: values.emailAddress
                }


                let so = this;
                spaapi.sendEmail(payload, t => {
                    this.isEmailLoading = false;
                },
                    f => {
                        this.isEmailLoading = false;
                    });
            },

            resendConfirmation: function () {
                this.sendEmail = !this.sendEmail;

            }

        }
    }
</script>
<style>
    .account-content .modal-container {
        height: 80vh !important
    }

    .account-content .modal-content {
        height: 100% !important;
    }

    .account-content .modal-body {
        overflow-y: auto !important;
        overflow-x: hidden;
        height: 90% !important;
    }
</style>
<style scoped>



    ul.guest-names {
        list-style: none;
    }

    .return-to-bookings {
        display: inline-block;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 15px;
        font-family: Montserrat;
        background-image: url(/Assets/img/booking/back-tab-arrow.svg);
        background-repeat: no-repeat;
        padding-left: 20px;
        background-position: left center;
        background-size: 6px 12px;
    }

    .amend-cancel-block {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

        .amend-cancel-block .btn {
            align-self: flex-start;
        }


    .spa-itinerary {
    }

        .spa-itinerary .item {
            list-style: disc;
            margin-bottom: 15px;
            position: relative;
        }



            .spa-itinerary .item:before {
                display: block;
                content: '';
                width: 1px;
                height: 15px;
                background: black;
                position: absolute;
                left: -11px;
                top: -15px;
            }

            .spa-itinerary .item:first-child::before {
                display: none;
            }

            .spa-itinerary .item:last-child {
                margin-bottom: 0;
            }


        .spa-itinerary .time {
            font-weight: bold;
            width: 80px;
            display: inline-block;
        }
</style>



<style>
    .treatments-list,
    .treatments-list li {
        list-style: none;
        padding: 0;
        font-size: 16px;
    }

    .booking .spa-summary h1,
    .booking .spa-summary h2 {
        font-size: 24px;
        margin-bottom: 30px;
        text-transform: none;
    }

    .spa-summary-group {
        margin-bottom: 40px;
        position: relative;
    }


        .spa-summary-group label {
            font-weight: bold;
            font-size: 14px !important;
            margin-bottom: 10px;
            text-transform: uppercase;
        }

    .spa-edit {
        border: none;
        background-color: transparent;
        position: absolute;
        right: 0%;
        top: 0%;
        height: 15px;
        text-indent: -9999px;
        width: 15px;
        background-position: center center;
        background-size: 15px 15px;
        background-repeat: no-repeat;
        background-image: url(/Assets/img/booking/edit.svg);
    }

    label.small {
        font-size: 12px;
    }

    .summary-add-on {
        border: solid 1px #aaa;
    }

        .summary-add-on .spa-edit {
            right: 15px;
        }

        .summary-add-on p {
            width: 85%
        }

    .bordered {
        border-left: solid 1px #aaa;
    }

    .bill {
        min-height: 75px;
    }



    .spa-total {
        font-size: 24px;
    }

    .spa-total-amount {
        font-weight: bold;
    }
    .lnk-print, .lnk-email {
        font-weight: bold;
    }
    .form-control[name=emailAddress] {
        height: 64px;
    }


</style>